import React from 'react';
import { Button, Link, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

const TroubleshootLinkButton = styled(Button)({
  cursor: 'pointer',
  padding: '5px 10px',
  marginRight: '20px',
  backgroundColor: '#10416D',
});

const TroubleshootButton: React.FC = () => {
  return (
    <>
      {process.env.REACT_APP_DIAGNOSTICS_URL &&
        <Tooltip title="Having trouble with joining meeting? Troubleshoot your connection." >
          <TroubleshootLinkButton onClick={() => window.open(process.env.REACT_APP_DIAGNOSTICS_URL, '_blank', 'noopener,noreferrer')} style={{ color: "white" }}>
            Troubleshoot
          </TroubleshootLinkButton>
        </Tooltip >
      }
    </>
  );

};

export default TroubleshootButton;
